module.exports = __webpack_public_path__ + "img/equalizer.825ad90b.svg";